var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginMicrosoftLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13225",
    "data-name": "Group 13225",
    transform: "translate(17412 -14522.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2817",
    "data-name": "Rectangle 2817",
    width: 10,
    height: 10,
    transform: "translate(-17412 14522.762)",
    fill: "#f65120"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2818",
    "data-name": "Rectangle 2818",
    width: 10,
    height: 10,
    transform: "translate(-17400 14534.762)",
    fill: "#ffb73c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2819",
    "data-name": "Rectangle 2819",
    width: 10,
    height: 10,
    transform: "translate(-17400 14522.762)",
    fill: "#7fb841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2820",
    "data-name": "Rectangle 2820",
    width: 10,
    height: 10,
    transform: "translate(-17412 14534.762)",
    fill: "#00a5e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMicrosoftLogin);
export default __webpack_public_path__ + "static/media/login-microsoft-login.03ebcb43d2d2a2b7c7738788d9b2d3a6.svg";
export { ForwardRef as ReactComponent };